import { TweenLite } from "gsap";
import { Track } from "../../AudioManager";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../ResourceManager/VideoResource";
import { Size, LogGroup, SetStyles, TranslateScreen2To1 } from "../.././MyHelpers";
import { CanvasSprite, CanvasSpriteSizing } from "../Sprite/CanvasSprite";
import { PickBonus, PickBonusElemGeometry, CommetReason, PickBonusFactory } from "./PickBonus";
import { PickBonusElement } from "./PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "./PickBonusParams";
import { PickBonusMessages } from "./PickMessage";
import { PickSprite } from "./PickSprite";
import { ZIndex } from "../../ZIndex";
import { Settings } from "../../Settings";

export class PickBonus_2Screen extends PickBonus
{
	public transition:HTMLElement=null;
	public TitleDragonLink:HTMLElement=null;

	public DragonLinkSprite:CanvasSprite = null;
	
	constructor(gameName: string, params: PickBonusParams)
	{
		super(gameName,params);
	}

	public override AudioPrepare(resourceManager:ResourceManager)
	{
		super.AudioPrepare(resourceManager);

		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/backgroundDrangonJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("Diamondwin")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/firetransition" + Settings.audioFormat, this.resid.ScopedResourceName("firetransition")));
		//Add new Voice for Dragon Jackpot
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/DragonJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("DiamondFamale")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/GrandJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("RubyFamale")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/Minor" + Settings.audioFormat, this.resid.ScopedResourceName("EmeraldFamale")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/Mini" + Settings.audioFormat, this.resid.ScopedResourceName("SapphireFamale")));
		//Load Voice Diamond POT
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/DragonLink" + Settings.audioFormat, this.resid.ScopedResourceName("diamond-pot")));
		//Load Trigger
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/DragonLinkTrigger" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		//BACKGROND TRANSITION
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/backgroundTransition" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundTransition")));
		//trigger end
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonTracks/startpick" + Settings.audioFormat, this.resid.ScopedResourceName("startpick")));
	
		

	}

	protected override PicksPrepare(resourceManager: IWriteOnlyResourceManager): void {
		super.PicksPrepare(resourceManager);
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_gold", this.resid.Add("pick_white"), true, this.logGroup.Add("pick_white"), true));
	}

	protected override SpriteLoaded(resourceManager:ResourceManager):void
	{
		this.pickCometSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame:  true, sizing:  CanvasSpriteSizing.Stretch});
		this.blueCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("BlueCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.redCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("RedCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.greenCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("GreenCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.whiteCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("WhiteCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		
		// this.pickCometSprite.View().style.zIndex = ""+ ZIndex.BonusPickComet; //"4";
		// this.blueCommetSprite.View().style.zIndex = ""+ ZIndex.Jp1Comet;//"4";
		// this.redCommetSprite.View().style.zIndex = ""+ ZIndex.Jp2Comet;//"4";
		// this.greenCommetSprite.View().style.zIndex = ""+ ZIndex.Jp3Comet;//"4";
		// this.whiteCommetSprite.View().style.zIndex = ""+ ZIndex.Jp4Comet;//"4";

		this.cometMap.set("pickCommet", this.pickCometSprite);
		//CHANGE BLUE PER GREEN
		this.cometMap.set("jp1", this.greenCommetSprite);

		//Red comet
		this.cometMap.set("jp3", this.redCommetSprite);

		//Green comet 
		//CHANGE GREEN PER BLUE
		this.cometMap.set("jp2", this.blueCommetSprite);

		//White commet
		this.cometMap.set("jp4", this.whiteCommetSprite);


		this.cometMap.forEach((commet:CanvasSprite)=>{
			commet.View().style.position = "absolute";
			this.view.appendChild(commet.View());
			//this.cometSize = commet.Size();

			commet.AddOnCompleteCallback(()=> this.CometComplete())
			commet.Hide();
		});

				
		
	}

	protected override async PicksLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		//let pickGeometries: PickBonusElemGeometry[] = this.PicksPositions();
		let numPickElements: number = 50;
		let pickGeometry: PickBonusElemGeometry = this.PicksPositions();

		let p: number = 0;
		for (let r = 0; r < PickBonus.MAX_ROWS; r++)
		{
			for (let c = 0; c < PickBonus.MAX_COLS; c++, p++)
			{
				this.pickSprite = new PickSprite();

				// TODO fix sprites to run at 24fps, to remove unnecessary frames!!
				this.pickSprite.spriteCoin = resourceManager.Get<SpriteResource>(this.resid.Add("pick_coin")).sprite;
				this.pickSprite.spriteCoin.config.props.fps = 72;
				
				//CHANGE BLUE PER GREEN
				this.pickSprite.spriteJp1 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_green")).sprite;
				this.pickSprite.spriteJp1.config.props.fps = 60;
				this.jpSpriteMap.set("jp1", this.pickSprite.spriteJp1);
				//CHANGE GREEN PER BLUE
				this.pickSprite.spriteJp2 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_blue")).sprite;
				this.pickSprite.spriteJp2.config.props.fps = 60;
				this.jpSpriteMap.set("jp2", this.pickSprite.spriteJp2);
	
				this.pickSprite.spriteJp3 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_red")).sprite;
				this.pickSprite.spriteJp3.config.props.fps = 60;
				this.jpSpriteMap.set("jp3", this.pickSprite.spriteJp3);
	
				this.pickSprite.spriteJp4 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_white")).sprite;
				this.pickSprite.spriteJp4.config.props.fps = 60;
				this.jpSpriteMap.set("jp4", this.pickSprite.spriteJp4);


				let canvasSprite: CanvasSprite = new CanvasSprite({sprite: this.pickSprite.spriteCoin, canvasSize: pickGeometry.displaySize});
				canvasSprite.View().style.transform="scale(1.2)";
				let params: PickBonusPickElementParams = new PickBonusPickElementParams(
					p,
					this.logGroup,
					pickGeometry.displaySize, 
					pickGeometry.pickRect, 
					pickGeometry.awardRect, 
					canvasSprite,
					this.pickSprite,
					this.resid.ScopedResourceName("award"),
				);

				let pick: PickBonusElement = this.params.pickElementFactory.CreatePickElement(params);
				
				pick.AddPickCallback((index: number) => this.OnPicked(index));
				pick.AddPickBonusAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
				pick.AddPickBonusRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));

				pick.View().classList.add("pickerContainer");
			
				this.picks.push(pick);

				this.pickRows[r].picks.push(pick);
				this.pickRows[r].view.appendChild(pick.View());
			}
		}
	}


	public TransitionPickBonus(resourceManager: IReadOnlyResourceManager)
	{
		this.transition=document.createElement("div");
		this.transition.style.width="1920px";
		this.transition.style.height="2160px";
		this.transition.style.backgroundImage=resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["transition"])).CssBackground();
		this.transition.style.display="none";
		this.transition.style.position="absolute";
		this.transition.style.bottom="0px";
		this.transition.style.zIndex=ZIndex.BonusTransition.toString();
		this.transition.style.alignContent="center";
		this.transition.style.justifyContent="center";
		

	/* 	this.TitleDragonLink=document.createElement("div");
		this.TitleDragonLink.style.width="1800px";
		this.TitleDragonLink.style.height="260px";
		this.TitleDragonLink.style.backgroundImage=resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["TitleDragonLink"])).CssBackground();
		this.TitleDragonLink.style.display="flex";
		//this.TitleDragonLink.style.position="absolute";
		//this.TitleDragonLink.style.top="0px";
		this.TitleDragonLink.style.zIndex=ZIndex.FreeGameIntroText.toString();
		
		this.TitleDragonLink.style.backgroundRepeat="no-repeat";
		this.TitleDragonLink.style.backgroundPosition="center";
		this.transition.appendChild(this.TitleDragonLink);
	 */
		this.DragonLinkSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("Dragon_link_sprite").Add("Title")).sprite, canvasSize: new Size(1920, 400)});
		this.DragonLinkSprite.View().style.position="absolute";
		this.DragonLinkSprite.View().style.top="416px";	
		this.transition.appendChild(this.DragonLinkSprite.View());
		this.DragonLinkSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("firetransition")));
		
	
		this.view.appendChild(this.transition);

		
	}
	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		await super.ResourcesLoaded(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) return;
		await this.TransitionPickBonus(resourceManager);
	}
	protected override CometComplete()
	{
		super.CometComplete();
	}

	public override ShowVideoTransition():void
	{
		//this.transition.style.display="flex";
		/* let videotransition: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("PickBonus").Add("Transition"));
		*/
		TweenLite.set(this.transition, {autoAlpha: 1, display: ""});
		this.DragonLinkSprite.Start(false);
		this.audio.Play(this.resid.ScopedResourceName("backgroundTransition"));
		
	
	
		// play audio with little delay
		setTimeout(() => 
		{

				if (this.session.currentPage == 0)
			{
				
				this.audio.Play(this.resid.ScopedResourceName("diamond-pot"));
			}
			
		}, 300);

		// setTimeout(()=>
		// {
			
		//  	TweenLite.to(this.transition, 0.5, {autoAlpha:0,display:"none",onComplete: () => 
		//  	TweenLite.to(this.transition, 0.5, {autoAlpha:1,display:"none"})
			
		
		// });
		
		
		// }, 1500); 
		
 	
	}

	
	

	protected override PrepareVideos(resourceManager: ResourceManager): void
	{
		//resourceManager.AddGlobal(new VideoResource(this.params.commonBonusResourcesBasePath + "video/transition.mp4", ResourceIdentifier.Global.Add("PickBonus").Add("Transition"), LogGroup.Global.Add("PickBonus").Add("Transition")));

		//DONT CREATE VIDEO TRANSITION IN 2Screen DONT USE 
	/* 	resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("PickBonus").Add("Transition"),
			logGroup: LogGroup.Global.Add("PickBonus").Add("Transition"),
			src: this.params.commonBonusResourcesBasePath + "video/transition.mp4",
			unloadOnEnd: true
		})); */

		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/white.mp4", ResourceIdentifier.Global.Add("jp4"), LogGroup.Global.Add("JP4Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp4"),
			logGroup: LogGroup.Global.Add("JP4Video"),
			src: "resources/multigame/slot/common/resources/PickBonus/video/white",
			unloadOnEnd: true
		}));

		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/red.mp4", ResourceIdentifier.Global.Add("jp3"), LogGroup.Global.Add("JP3Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp3"),
			logGroup: LogGroup.Global.Add("JP3Video"),
			src: "resources/multigame/slot/common/resources/PickBonus/video/red",
			unloadOnEnd: true
		}));
		
		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/green.mp4", ResourceIdentifier.Global.Add("jp2"), LogGroup.Global.Add("JP2Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp2"),
			logGroup: LogGroup.Global.Add("JP2Video"),
			src: "resources/multigame/slot/common/resources/PickBonus/video/blue",
			unloadOnEnd: true
		}));

		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/blue.mp4", ResourceIdentifier.Global.Add("jp1"), LogGroup.Global.Add("JP1Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp1"),
			logGroup: LogGroup.Global.Add("JP1Video"),
			src: "resources/multigame/slot/common/resources/PickBonus/video/green",
			unloadOnEnd: true
		}));
	}

	protected override VideosLoaded(resourceManager: IReadOnlyResourceManager): void
	{
		//dont Create video resource because dont use in 2Screen
		/* // make sure transition covers everything
		let transition: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("PickBonus").Add("Transition")).video;
		SetStyles(transition.View(), {position: "absolute", top: "0px", left: "0px", zIndex: "" + ZIndex.BonusTransition});
		this.systemContext.SharedVideoContext().AddVideo(transition);
 */
		// make sure jackpot videos loop
		let jp4 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp4")).video;
		//jp4.video.loop = true;
		SetStyles(jp4.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp4);

		let jp3 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp3")).video;
		//jp3.video.loop = true;
		SetStyles(jp3.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp3);

		let jp2 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp2")).video;
		//jp2.video.loop = true;
		SetStyles(jp2.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp2);

		let jp1 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp1")).video;
		//jp1.video.loop = true;
		SetStyles(jp1.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp1);
	}
	
	protected override CommetJP(message:PickBonusMessages.CommetJp)
	{
		let srcRect = TranslateScreen2To1(message.srcRect);
		let destRect = TranslateScreen2To1(message.destRect);

		this.StartCommet(srcRect.Center(), destRect.Center(), CommetReason.JpWin);
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		
		await super.PrepareResources(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) return;
		
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "transition.png", this.resid.ScopedResourceName(["transition"])));
		
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "Dragon_link_sprite", ResourceIdentifier.Global.Add("Dragon_link_sprite").Add("Title"), true, LogGroup.Global.Add("Dragon_link_sprite").Add("Title"), true))
		

	}
	public override Update()
	{
		super.Update();
		this.DragonLinkSprite.Update();
	}

}

export class PickBonusFactory_2Screen extends PickBonusFactory
{
	public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus
	{
		return new PickBonus_2Screen(gameName, params);
	}
	
	
	public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement
	{
		return new PickBonusElement(params);
	}
}